<template>
  <div>
    <loading-block v-if="dataIsLoading">
    </loading-block>
    <div v-else>
      <div class="admin-title">
        <h1 class="main-title">{{ prettyName }}</h1>
        <uni-cta-link class="ini-cta-link--small uni-cta-link--secondary" style="width: auto;"
                      :to="{name: 'admin.families.edit', params: {id: user.family_id}}">Voir la famille
        </uni-cta-link>
      </div>
      <p>né(e) le {{ $birthDate(user.birth_date) }} ({{ $getAge(user.birth_date) }} ans)</p>
      <div class="section-container">
        <section>
          <h2 class="subtitle">Informations générales</h2>
          <ValidationObserver ref="observer"
                              v-slot="{ invalid }"
                              tag="form"
                              @submit.prevent="updateUserInfos()"
                              class="form-container"
          >
            <info-message v-if="userUpdateSuccess" status="success">
              Modifications enregistrées
            </info-message>
            <uni-input-container label="Prénom" for="firstname">
              <uni-input rules="alpha_dash|required"
                         v-model="user.firstname"
                         id="firstname"
                         :val="user.firstname"
              />
            </uni-input-container>

            <uni-input-container label="Nom">
              <uni-input rules="alpha_dash|required"
                         v-model="user.name"
                         id="name"
                         :val="user.name"
              />
            </uni-input-container>
            <uni-input-container label="Date de naissance">
              <uni-input rules="required"
                         v-model="user.birth_date"
                         id="birth-date"
                         :val="user.birth_date"
                         type="date"
              />
            </uni-input-container>

            <uni-input-container label="Email">
              <uni-input rules="email"
                         v-model="user.email"
                         id="email"
                         :val="user.email"
              />
            </uni-input-container>
            <uni-input-container label="Adresse" for="street">
              <uni-input rules="required"
                         v-model="user.street"
                         id="street"
                         :val="user.street"
              />
            </uni-input-container>

            <uni-input-container label="Code postal"
                                 for="postalCode">
              <uni-input rules="required|digits:5"
                         v-model="user.postal_code"
                         id="postalCode"
                         mode="eager"
                         :val="user.postal_code"
              />
            </uni-input-container>

            <uni-input-container label="Ville" for="city">
              <uni-input rules="required"
                         v-model="user.city"
                         id="city"
                         :val="user.city"
              />
            </uni-input-container>

            <!-- <p>Né(e) le {{ user.birth_date }}</p>-->

            <div v-if="!user.isMinor">
              <uni-input-container label="Adresse e-mail" for="email">
                <uni-input rules="required|email"
                           v-model="user.email"
                           id="email"
                           :val="user.email"
                />
              </uni-input-container>
              <uni-input-container label="Téléphone"
                                   for="tel"
              >
                <uni-input rules="required|digits:10"
                           v-model="user.tel"
                           id="tel"
                           :val="user.tel"
                />
              </uni-input-container>
            </div>
            <uni-loading-button v-if="currentFamily.isPayment" :is-disable="loading"
                                text="Enregistrer les modifications"/>
            <uni-loading-button v-if="currentFamily.isPayment" style="margin-top: 1rem;"
                                @click.native.prevent="warning = true"
                                class="button--warning" :is-disable="loading" text="Supprimer le danseur"/>

          </ValidationObserver>
        </section>
        <section class="courses">
          <div class="certificate" v-if="user.is_dancer">
            <h2>Certificat médical</h2>
            <div v-if="user.medical_certificate">
              <p>Certificat actuel : <a style="margin-top: .5rem;" target="_blank"
                                        :href="user.medical_certificate.attachment">certificat_medical.{{ user.medical_certificate.filename.split('.')[1] }}</a>
              </p>
              <div v-if="!user.medical_certificate.year">
                <input-file v-if="currentFamily.isPayment" style="margin-bottom: 1rem;" id="testFile"
                            :loading="certificateLoading"
                            :has-certificate="user.medical_certificate"
                            @change="updateFile"></input-file>

                <div class="select-year" v-if="currentFamily.isPayment">
                  <uni-input v-model="inputYear" placeholder="Année"></uni-input>
                  <uni-loading-button @click.native="valideCertificate" :is-disable="loadYear"
                                      text="OK"></uni-loading-button>
                </div>
              </div>
              <div v-else>
                <p class="success">Certificat validé. (année: {{ user.medical_certificate.year }})</p>
              </div>
            </div>
            <div v-else>
              <p class="danger">Certificat médical manquant. veuillez ajouter
                un certificat médical afin de valider les inscriptions.</p>
              <input-file v-if="currentFamily.isPayment" id="testFile" :loading="certificateLoading"
                          :has-certificate="user.medical_certificate" @change="updateFile"></input-file>
            </div>

          </div>
          <div class="duo-title" v-if="user.is_dancer">
            <h2>Cours</h2>
            <rich-add-link v-if="user.current_courses.length < 3 && currentFamily.isPayment"
                           :to="{name:'admin.courses.new', id:user.id}"
                           label="Inscrire à un cours"/>
          </div>
          <div v-if="user.is_dancer">
            <div v-if="user.current_courses.length > 0">
              <rich-course-card v-for="course in user.current_courses"
                                :course="course"
                                :key="course.id"
                                :admin="true"
              >
                <template slot="action">
                  <div>
                    <uni-loading-button v-if="currentFamily.isPayment" @click.native="removeCourse(course)"
                                        style="margin-top: 1rem; padding: 0 8px; min-height: 32px;"
                                        class="button--extra-small button--warning"
                                        :is-disable="deleteCourse"
                                        text="Supprimer"></uni-loading-button>
                  </div>
                </template>
              </rich-course-card>
            </div>
            <div v-else>
              Inscrit à aucun cours
            </div>
          </div>
        </section>
        <section v-if="$getAge(user.birth_date) < 18">
          <h2 style="margin-bottom: 1rem;">Responsables légaux</h2>
          <rich-add-button v-if="user.legal_resps.length < 2 && currentFamily.isPayment" style="margin-bottom: 1rem;"
                           @click.native.prevent="openRespModal"
                           label="Ajouter un responsable"
          >

          </rich-add-button>

          <rich-people-list @emitResp="deleteResp" :resp="true" :count="user.legal_resps.length"
                            :users="user.legal_resps"/>

        </section>
      </div>
      <pop-from-bottom :open="openSectionAddResp"
                       title="Ajout d'un responsable légal"
                       @close="closeRespModal"
      >
        <template slot="content">
          <div v-if="!respForm">
            <ValidationObserver ref="respObserver"
                                v-slot="{ invalid }"
                                tag="form"
                                class="form-container"
                                @submit.prevent="submitResps()">
              <validation-provider rules="required|checkRespsOne"
                                   v-slot="{ errors, classes }"
                                   tag="div">
                <uni-input-checkbox v-for="resp in resps"
                                    :index="resp.id"
                                    :label="resp.firstname+' '+resp.name"
                                    :id="resp.id"
                >

                  <input type="checkbox"
                         :id="resp.id"
                         :value="resp.id"
                         v-model="newResps"
                         checked="checked"
                  >
                </uni-input-checkbox>
                <span>{{ errors[0] }}</span>
              </validation-provider>
              <rich-add-button style="margin-bottom: 1rem;"
                               @click.native="respForm = true"
                               label="Créer un responsable"
              >

              </rich-add-button>
              <uni-button @click.native.prevent="addRespToUser">
                Ajouter le responsable
              </uni-button>
            </ValidationObserver>
          </div>
          <div v-else>
            <ValidationObserver ref="addRespObserver"
                                v-slot="{ invalid }"
                                tag="form"
                                @submit.prevent="submitANewResp()"
            >
              <uni-input-container label="Prénom" for="firstname">
                <uni-input rules="alpha_dash|required"
                           v-model="newResp.firstname"
                           id="firstname"
                />
              </uni-input-container>

              <uni-input-container label="Nom">
                <uni-input rules="alpha_dash|required"
                           v-model="newResp.name"
                           id="name"
                />
              </uni-input-container>

              <uni-input-container label="Adresse" for="street">
                <uni-input rules="required"
                           v-model="newResp.street"
                           id="street"
                />
              </uni-input-container>

              <uni-input-container label="Code postal"
                                   for="postalCode">
                <uni-input rules="required|digits:5"
                           v-model="newResp.postal_code"
                           id="postalCode"
                           mode="eager"
                />
              </uni-input-container>

              <uni-input-container label="Ville" for="city">
                <uni-input rules="required"
                           v-model="newResp.city"
                           id="city"
                />
              </uni-input-container>

              <uni-input-container label="Adresse e-mail" for="email">

                <uni-input rules="required|email"
                           v-model="newResp.email"
                           id="email"
                />
              </uni-input-container>
              <uni-input-container label="Téléphone"
                                   for="tel"
              >
                <uni-input rules="required|digits:10"
                           v-model="newResp.tel"
                           id="tel"
                />
              </uni-input-container>

              <input-birthday v-model="newResp.birth_date" id="birthDateResp"></input-birthday>

              <rich-yes-no-input question="Cette personne danse ?"
                                 name="isNewRespDancing"
                                 v-model="newResp.is_dancer"
              />
              <div v-if="newResp.is_dancer">
                <rich-yes-no-input question="Autorisez vous le droit à l'image"
                                   name="respImageRight"
                                   v-model="newResp.is_image_allowed"
                                   message="Si vous cochez « Non », vous ne pourrez pas participer au spectacle de fin d’année"
                />
              </div>
              <uni-button @click.native="createNewResp">Créer le responsable légal</uni-button>
            </ValidationObserver>
          </div>
        </template>
      </pop-from-bottom>
      <pop-from-bottom :open="warning" title="Suppression d'un danseur" @close="warning = false">
        <template slot="content">
          <p>Cette action entraînera la suppression de ce danseur, ainsi que toutes les demandes
            d'inscriptions aux
            cours.</p>
          <p>Voulez-vous vraiment supprimer ce danseur ?</p>
        </template>

        <template slot="bottom">
          <div class="action-button">
            <uni-loading-button :is-disable="deleteLoading" text="Supprimer" class="button--warning"
                                @click.native="deleteUser">
            </uni-loading-button>
            <uni-button @click.native.prevent="warning = false" class="button--secondary">
              Annuler
            </uni-button>

          </div>
        </template>
      </pop-from-bottom>
    </div>
  </div>
</template>

<script>
import RichHeaderSecondaryLevel from "../../components/c-blocks/RichHeaderSecondaryLevel";
import UniInputContainer from "../../components/a-elements/UniInputContainer";
import UniInput from "../../components/a-elements/UniInput";
import UniInputDate from "../../components/a-elements/UniInputDate";
import UniButton from "../../components/a-elements/UniButton";
import {mapGetters} from "vuex";
import LoadingBlock from "../../components/c-blocks/LoadingBlock";
import RichAddLink from "../../components/a-elements/RichAddLink";
import RichCourseCard from "../../components/a-elements/RichCourseCard";
import InfoMessage from "../../components/a-elements/InfoMessage";
import InputFile from "../../components/a-elements/InputFile";
import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
import RichPeopleList from "../../components/b-patterns/RichPeopleList";
import RichAddButton from "../../components/a-elements/RichAddButton";
import PopFromBottom from "../../components/c-blocks/PopFromBottom";
import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
import InputBirthday from "../../components/a-elements/InputBirthday";
import UniInputCheckbox from "../../components/a-elements/UniInputCheckbox";
import UniCtaLink from "../../components/a-elements/UniCtaLink";

export default {
  name: "edit",
  components: {
    UniCtaLink,
    UniInputCheckbox,
    InputBirthday,
    RichYesNoInput,
    PopFromBottom,
    RichAddButton,
    RichPeopleList,
    UniLoadingButton,
    InputFile,
    InfoMessage,
    RichCourseCard,
    RichAddLink,
    LoadingBlock, UniButton, UniInputDate, UniInput, UniInputContainer, RichHeaderSecondaryLevel
  },
  data() {
    return {
      user: {},
      deleteCourse: false,
      dataIsLoading: true,
      prettyName: '',
      userUpdateSuccess: false,
      file: '',
      loading: false,
      deleteLoading: false,
      warning: false,
      btnLoading: false,
      certificateLoading: false,
      openSectionAddResp: false,
      respForm: false,
      loadYear: false,
      inputYear: '',
      family: {},
      newResp: {
        name: "",
        firstname: "",
        email: "",
        tel: "",
        is_dancer: null,
        birth_date: null,
        is_image_allowed: '',
        street: "",
        postal_code: "",
        city: "",
        isNewRespDancing: false
      },
      resps: [],
      newResps: [],

      selectedYear: null
    }
  },
  computed: {
    ...mapGetters({
      currentFamily: 'currentFamily',
      currentYear: 'currentYear'
    })
  },
  methods: {

    valideCertificate() {
      this.loadYear = true
      if (this.inputYear.length === 4) {
        this.$updateCertificate(this.user.id, this.user.medical_certificate.id, {
          year: this.inputYear,
          user_id: this.user.id
        })
            .then(data => {
              this.user.medical_certificate.year = data.year
            })
      }
      this.loadYear = false
    },
    deleteResp(model) {
      this.$deleteRespFromUser(this.user.id, model.id)
          .then(data => {
            let index = this.user.legal_resps.indexOf(model)
            this.user.legal_resps.splice(index, 1)
          })
    },
    deleteUser() {
      this.deleteLoading = true
      this.$deleteModel('users', this.user.id)
          .then(data => {
            this.$router.push('/')
          })
    },

    closeRespModal() {
      this.respForm = false
      this.openSectionAddResp = false
      this.resps = []
      this.newResp = []
    },

    addRespToUser() {
      this.newResps.forEach(el => {
        this.$addRespToUser(this.user.id, el)
            .then(data => {
              this.user.legal_resps.push(data)
              this.openSectionAddResp = false
              this.resps = []
            })
      })

      this.newResps = []
    },

    openRespModal() {
      this.openSectionAddResp = true
      this.$getUsers(this.user.family_id)
          .then(req => {
            let resps = req.filter(el => this.$getAge(el.birth_date) >= 18)
            resps.forEach(el => {
              if (!this.user.legal_resps.find(x => x.id === el.id)) {
                this.resps.push(el)
              }
            })

          })
    },
    async submitResps() {
      const isValid = await this.$refs.respObserver.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Checkbox uncomplete')
      } else {
        // 🐿 ship it
        this.actualSection.name = 'certificate'
        this.actualSection.title = 'Étape finale : certificat médical'
      }
    },
    async submitANewResp() {
      const isValid = await this.$refs.addRespObserver.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Form for new resp is uncomplete')
      } else {
        // 🐿 ship it
        console.log('New Resp submit')
        this.showSectionAddResp = false
      }
    },
    createNewResp() {
      const user = {
        user: {
          ...this.newResp,
          family_id: this.currentFamily.id
        }
      }

      this.$createModel('users', user)
          .then(data => {
            this.resps.push(data)
            this.respForm = false
          })

    },
    removeCourse(course) {
      this.deleteCourse = true
      this.$deleteCourseOfUser(this.user.id, course.id)
          .then(data => {
            let index = this.user.current_courses.indexOf(course)
            this.user.current_courses.splice(index, 1)
            this.user.courses_count -= 1
            this.deleteCourse = false
          })
    },
    updateUserInfos() {

      this.loading = true

      this.$updateModel('users', {user: this.user}, this.user.id)
          .then(data => {

            console.log('infos successfully updated')
            this.userUpdateSuccess = true
            window.setTimeout(() => {
              this.userUpdateSuccess = false
            }, 3000)
            this.loading = false
          })
          .catch(data => {
            console.log('what ça a pas fonctionné')
          })

    },
    updateFile(e) {
      this.certificateLoading = true
      const image = {
        'certificate': e.target.files[0]
      }

      let formData = new FormData()

      Object.entries(image).forEach(
          ([key, value]) => formData.append(key, value)
      )
      this.$createCertificate(this.$route.params.id, formData)
          .then(data => {
            this.certificateLoading = false
            this.user.medical_certificate = data
          })
    }
  },
  created() {
    this.$adminGetUser(this.$route.params.id)
        .then(data => {
          this.selectedYear = this.currentYear.id
          this.user = data
          this.user.isMinor = true
          this.$isDateInRange(data.created_at, data.updated_at)
          this.$nextTick(() => {
            this.prettyName = this.$sexyName(this.user.firstname, this.user.name)
            this.$getModel('families', data.family_id)
                .then(req => {
                  this.family = req
                  this.dataIsLoading = false
                })

          })
        })

  },
  beforeRouteUpdate(to, from, next) {
    this.dataIsLoading = true
    this.$adminGetUser(to.params.id)
        .then(data => {
          this.user = data
          this.user.isMinor = true
          this.$nextTick(() => {
            this.prettyName = this.$sexyName(this.user.firstname, this.user.name)
            this.$getModel('families', data.family_id)
                .then(req => {
                  this.family = req
                  this.dataIsLoading = false
                })

          })
        })
    next()
  }
}
</script>

<style scoped lang="scss">

.action-button {
  button:first-child {
    margin-bottom: 1rem;
  }
}

.section-container {
  display: grid;
  gap: 24px;
}

.duo-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.courses {
  margin-bottom: 32px;

  .card {
    margin-bottom: 16px;
  }

  .certificate {
    margin-bottom: 1rem;
  }

}

@include screen-m {

  .admin-title {
    display: flex;
    justify-content: flex-start;

    > a {
      margin-left: 2rem;
    }
  }
  .select-year {
    display: flex;
    align-items: center;

    > div {
      width: 100px;
      margin-right: 1rem;
    }

    button {
      width: 100px;
    }
  }
  .action-button {
    display: flex;
    flex-direction: row-reverse;

    > button:last-child {
      padding: 0 30px;
      margin-right: 1rem;
    }

    > button:first-child {
      margin-bottom: 0;
    }

    > button {
      width: 50%;
    }
  }
  .duo-title {
    margin-bottom: 16px;
  }

  .section-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}
</style>
